import { makeGetRequest, makePostRequest } from "../makeRequest";
import appConfig from "../../config/app.config";

export const getAllPartnersList = async () => {
  try {
    const allPartnersList = await makeGetRequest(appConfig.apiUrl.partnerList);
    return allPartnersList.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};

export const getPartnerConfigById = async (id) => {
  try {
    const partnerConfig = await makeGetRequest(
      `${appConfig.apiUrl.partnerList}/${id}`
    );
    return partnerConfig.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};

export const updatePartnerConfig = async (data) => {
  try {
    const updatedPartnerConfig = await makePostRequest(
      appConfig.apiUrl.partnerList,
      data
    );
    return updatedPartnerConfig.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};
